/** @jsx jsx */
import { Fragment, useEffect } from 'react'
import moment from 'moment'
import { Button, jsx, Text } from 'theme-ui'
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'
import { useGiftCards } from '~/hooks/components/use-gift-cards'

const LineItemGiftCardValue = ({ label, value }) => {
  return (
    <Text
      as="p"
      variant="body3"
      m={0}
      sx={{
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      <strong>{label}: </strong>
      {value}
    </Text>
  )
}

const LineItemGiftCard = ({
  giftCard,
  handleRemove,
  orderConfirmed,
  setIsLoading,
}) => {
  const { applyGiftCardDetails } = useGiftCards()
  const translate = useTranslate()
  const {
    giftMessage,
    id,
    filled,
    purchaserName,
    recipientEmail,
    sendEmailAt,
  } = giftCard

  useEffect(() => {
    const applyDetails = async () => {
      setIsLoading(true)
      await applyGiftCardDetails(id)
      setIsLoading(false)
    }

    if (id && !filled) applyDetails()
  }, [applyGiftCardDetails, id, filled, setIsLoading])

  return (
    <Fragment>
      {recipientEmail && (
        <Fragment>
          {purchaserName && (
            <LineItemGiftCardValue
              label={translate('gift_card.purchaser_name')}
              value={purchaserName}
            />
          )}
          <LineItemGiftCardValue
            label={translate('gift_card.email')}
            value={recipientEmail}
          />
          {sendEmailAt && !moment(sendEmailAt).isSame(moment(), 'day') && (
            <LineItemGiftCardValue
              label={translate('gift_card.date')}
              value={moment(sendEmailAt).format('l')}
            />
          )}
          {giftMessage && (
            <LineItemGiftCardValue
              label={translate('gift_card.gift_message')}
              value={giftMessage}
            />
          )}
        </Fragment>
      )}
      {!recipientEmail && (
        <Text as="p" variant="body3" color="error">
          {'An error occurred. Please remove this gift card and try again.'}
        </Text>
      )}
      {!orderConfirmed && (
        <Button variant="reset" m={0} onClick={() => handleRemove(id)}>
          <Text
            as="span"
            variant="body3"
            sx={{ color: 'brandPrimary', textDecoration: 'underline' }}
          >
            {'Remove'}
          </Text>
        </Button>
      )}
    </Fragment>
  )
}

export default LineItemGiftCard
